import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "ChipCounter"
})
export default class ChipCounter extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => "" }) name!: string;
  @Prop({ default: () => 0 }) length!: number;
}
